import React, { Component } from "react";
import { connect } from "react-redux";

import { Container, KeyboardView } from "app/NativeComponents/common";
import {
  Header,
  NewHeader,
  SelectItem,
  SmallLabel
} from "app/NativeComponents/snippets";

import Body from "./Body";

import {
  updateUser,
  setModal,
  toggleModal,
  uploadProfileAnimation,
  popSidePanel,
  changeTab,
  uploadFile,
  /*common functions*/
  dismissMobileKeyboard
} from "app/NativeActions";

var md5 = require("js-md5");

class EditBasicInformation extends Component {
  constructor(props) {
    super(props);

    this.state = {
      user: props.user,
      loading: false
    };

    this.saveUserInfo = this.saveUserInfo.bind(this);
    this.checkIfNeedsToSave = this.checkIfNeedsToSave.bind(this);
    this.updateUserFieldChange = this.updateUserFieldChange.bind(this);
  }

  componentDidMount() {
    if (!this.props.user.image || this.props.user.image == "") {
      var hash = md5(this.props.user.email);
      const url = "https://www.gravatar.com/avatar/" + hash + "?s=100.jpg&d=mm";
      this.updateUserFieldChange({ prop: "image", value: url });
    }
  }

  checkIfNeedsToSave() {
    if (
      (this.props.user.firstname != this.state.user.firstname ||
        this.props.user.lastname != this.state.user.lastname ||
        this.props.user.username != this.state.user.username ||
        this.props.user.company != this.state.user.company ||
        this.props.user.image != this.state.user.image) /*||
      this.props.user.user_phone != this.state.user.user_phone*/ &&
      !!this.state.user.firstname &&
      !!this.state.user.lastname /*&&
      !!this.state.user.user_phone*/
    ) {
      return true;
    }

    return false;
  }

  updateUserFieldChange({ prop, value }) {
    this.setState({
      user: {
        ...this.state.user,
        [prop]: value
      }
    });
  }

  handleBack() {
    dismissMobileKeyboard();
    this.props.popSidePanel();
  }

  saveUserInfo() {
    /*mobile*/
    dismissMobileKeyboard();

    const { firstname, lastname, username, company, user_phone, image } =
      this.state.user;
    this.props.updateUser({
      token: this.props.token,
      type: "update_information",
      /*type:
        user_phone != this.props.user.phone
          ? "update_user_information_phone"
          : "update_user_information",*/
      payload: {
        firstname,
        lastname,
        username,
        company,
        image,
        use_image: this.props.user.use_image
      },
      onLoading: () => {
        this.setState({
          loading: true
        });
      },
      onError: () => {
        this.setState({
          loading: false
        });
      },
      onSuccess: () => {
        this.setState({
          loading: false
        });

        this.handleBack();
      }
    });
  }

  render() {
    return (
      <Container>
        <NewHeader
          title="Edit User Information"
          leftButton={{
            icon: "arrow-back",
            onPress: () => {
              this.handleBack();
            }
          }}
        />
        <KeyboardView style={{ flex: 1 }}>
          <Body
            {...this.props}
            editUser={this.state.user}
            loading={this.state.loading}
            saveUserInfo={this.saveUserInfo}
            checkIfNeedsToSave={this.checkIfNeedsToSave}
            updateUserFieldChange={this.updateUserFieldChange}
          />
        </KeyboardView>
      </Container>
    );
  }
}

const mapStateToProps = ({ auth, native, settings }) => {
  const { token, user } = auth;
  const { device } = native;
  const { colors } = settings;

  return { token, user, device, colors };
};

export default connect(mapStateToProps, {
  updateUser,
  setModal,
  toggleModal,
  uploadProfileAnimation,
  popSidePanel,
  changeTab,
  uploadFile
})(EditBasicInformation);
